// SanAPI getMetric price-metric name for a pair's quote asset. The mapping is
// derived from the quote string alone (case-insensitive on input) —
// deliberately no lookup table (any curated table breaks every asset missing
// from it; consumers must never gate this mapping on a pairs inventory).
// The result is only a metric NAME — whether SanAPI has data for it is the
// caller's concern.
export function metricForQuote(quote: string): string {
  return `price_${quote.toLowerCase()}`;
}
